import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/app.js';
import './shared/ui/styles/tokens.css';

const container = document.querySelector('#root');
if (container === null) {
  throw new Error('No se encontró el contenedor #root.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
